import { render, staticRenderFns } from "./user-group-container.vue?vue&type=template&id=21c9cb86&"
import script from "./user-group-container.vue?vue&type=script&lang=tsx&"
export * from "./user-group-container.vue?vue&type=script&lang=tsx&"
import style0 from "./user-group-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports